import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Portfolio() {
    return (
        <div className="inner-page">

            <Header />


            <div className="rts-breadcrumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="baread-crumb-main-wrapper pt--100">
                                <div className="inner">
                                    <h1 className="title rts_hero__title">Portfolio</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="rts-portfolio-grid-area column">
                <div className="container-140">
                    <div className="row g-0 separetor-portfolio-bottom">
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="signle-portfolio-style-four-inner">
                                <a href="https://www.snaoushadhasala.com/" className="thumbnail rts-slide-up-gsap" target='blank'>
                                    <img src="assets/images/product/sna.jpeg" alt="product" />
                                </a>
                                <div className="inner-content">
                                    <span>Website</span>
                                    <a href="https://www.snaoushadhasala.com/" target='blank'>
                                        <h5 className="name">SNA Oushadhasala</h5>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="signle-portfolio-style-four-inner">
                                <a href="https://www.snaoushadhasala.com/" className="thumbnail rts-slide-up-gsap" target='blank'>
                                    <img src="assets/images/product/sna.jpeg" alt="product" />
                                </a>
                                <div className="inner-content">
                                    <span>Website</span>
                                    <a href="https://www.snaoushadhasala.com/" target='blank'>
                                        <h5 className="name">SNA Oushadhasala</h5>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="signle-portfolio-style-four-inner">
                                <a href="https://www.snaoushadhasala.com/" className="thumbnail rts-slide-up-gsap" target='blank'>
                                    <img src="assets/images/product/sna.jpeg" alt="product" />
                                </a>
                                <div className="inner-content">
                                    <span>Website</span>
                                    <a href="https://www.snaoushadhasala.com/" target='blank'>
                                        <h5 className="name">SNA Oushadhasala</h5>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="signle-portfolio-style-four-inner">
                                <a href="https://www.snaoushadhasala.com/" className="thumbnail rts-slide-up-gsap" target='blank'>
                                    <img src="assets/images/product/sna.jpeg" alt="product" />
                                </a>
                                <div className="inner-content">
                                    <span>Website</span>
                                    <a href="https://www.snaoushadhasala.com/" target='blank'>
                                        <h5 className="name">SNA Oushadhasala</h5>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="signle-portfolio-style-four-inner">
                                <a href="https://www.snaoushadhasala.com/" className="thumbnail rts-slide-up-gsap" target='blank'>
                                    <img src="assets/images/product/sna.jpeg" alt="product" />
                                </a>
                                <div className="inner-content">
                                    <span>Website</span>
                                    <a href="https://www.snaoushadhasala.com/" target='blank'>
                                        <h5 className="name">SNA Oushadhasala</h5>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="signle-portfolio-style-four-inner">
                                <a href="https://www.snaoushadhasala.com/" className="thumbnail rts-slide-up-gsap" target='blank'>
                                    <img src="assets/images/product/sna.jpeg" alt="product" />
                                </a>
                                <div className="inner-content">
                                    <span>Website</span>
                                    <a href="https://www.snaoushadhasala.com/" target='blank'>
                                        <h5 className="name">SNA Oushadhasala</h5>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="signle-portfolio-style-four-inner">
                                <a href="https://www.snaoushadhasala.com/" className="thumbnail rts-slide-up-gsap" target='blank'>
                                    <img src="assets/images/product/sna.jpeg" alt="product" />
                                </a>
                                <div className="inner-content">
                                    <span>Website</span>
                                    <a href="https://www.snaoushadhasala.com/" target='blank'>
                                        <h5 className="name">SNA Oushadhasala</h5>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="signle-portfolio-style-four-inner">
                                <a href="https://www.snaoushadhasala.com/" className="thumbnail rts-slide-up-gsap" target='blank'>
                                    <img src="assets/images/product/sna.jpeg" alt="product" />
                                </a>
                                <div className="inner-content">
                                    <span>Website</span>
                                    <a href="https://www.snaoushadhasala.com/" target='blank'>
                                        <h5 className="name">SNA Oushadhasala</h5>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">

                            <div className="signle-portfolio-style-four-inner">
                                <a href="https://www.snaoushadhasala.com/" className="thumbnail rts-slide-up-gsap" target='blank'>
                                    <img src="assets/images/product/sna.jpeg" alt="product" />
                                </a>
                                <div className="inner-content">
                                    <span>Website</span>
                                    <a href="https://www.snaoushadhasala.com/" target='blank'>
                                        <h5 className="name">SNA Oushadhasala</h5>
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            <Footer />


            <div className="loading-screen" id="loading-screen">
                <span className="bar top-bar"></span>
                <span className="bar down-bar"></span>
                <span className="progress-line"></span>
                <span className="loading-counter"> </span>
            </div>


            <div className="bg-noise"></div>



            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
                </svg>
            </div>

            <div className="rts-cursor cursor-outer" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor"></span>
            </div>
            <div className="rts-cursor cursor-inner" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor">
                    <span className="fn-left"></span>
                    <span className="fn-right"></span>
                </span>
            </div>

            <div className="modal-sidebar-scroll rts-dark-light">
                <ul>
                    <li className="go-dark-w"><span>Dark</span><i className="rts-go-dark fal fa-moon"></i></li>
                    <li className="go-light-w"><span>Light</span><i className="rts-go-light fa-light fa-brightness"></i></li>
                </ul>
            </div>
        </div>


    )
}

export default Portfolio
